import React, { useEffect, useState } from "react";
import { getScoreAPI2 } from "../service/cricket";


export default function CustomScoreCard({ eventId }) {
  const [scoreData, setScoreData] = useState(null);
  useEffect(() => {
    if (!eventId) return;
    const fetchScoreData = async () => {
      try {
        const { response, code } = await getScoreAPI2(eventId);
        if (code === 200) {
          setScoreData(response?.data?.score);
        }
      } catch (err) {
        console.error("Error fetching score:", err);
      }
    };

    fetchScoreData();
    const interval = setInterval(fetchScoreData, 5000);
    return () => clearInterval(interval);
  }, [eventId]);

  if (!scoreData)
    return (
      <div className="Diamond_scoreboard" >
        <div
          className="scorecard" 
          style={{
            backgroundImage: "url('../../assets/images/ground_img.bf0722425e5c2daab204.jpg')",
            height : "102px"
          }}
        />
      </div>
    );
    
  const {
    spnnation1,
    spnnation2,
    score1,
    score2,
    spnrunrate2,
    spnmessage,
    balls,
  } = scoreData;


  return (
    <div className="Diamond_scoreboard">
      <div className="scorecard" style={{
        backgroundImage: "url('../../assets/images/ground_img.bf0722425e5c2daab204.jpg')",
      }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-6">
              <p className="team-1 row mt-2">
                <span className="team-names col-3">{spnnation1}</span>
                <span className="score col-4 text-end">{score1}</span>
                <span className="team-names col-5" />
              </p>
              <p className="team-1 row">
                <span className="team-names col-3">{spnnation2}</span>
                <span className="score col-4 text-end">{score2}</span>
                <span className="team-names col-5">
                  <span>CRR {spnrunrate2}</span>
                </span>
              </p>
            </div>

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-12">
                  <div className="text-xl-end">
                    <span>{spnmessage}</span>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <p className="text-xl-end ball-by-ball mt-2 mb-0">
                        {balls?.map((ball, idx) => (
                          <span
                            key={idx}
                            className={`ball-runs ${ball === "4"
                              ? "four"
                              : ball === "6"
                                ? "six"
                                : ball.toLowerCase().includes("w")
                                  ? "wicket"
                                  : "run"
                              }`}
                          >
                            {ball}
                          </span>
                        ))}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
